import React from "react";

const OtitisCond = () => {
  return (
    <div className="bg-gray-10 p-2 flex flex-col max-w-[400px]">
      <p className="text-teal-300 text-left text-body-sm font-normal">
        Chronic or recurrent ear infections
      </p>
    </div>
  );
};

export default OtitisCond;
